"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _prop2 = _interopRequireDefault(require("lodash/fp/prop"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(property) {
  if (property === null || property === undefined) {
    throw new Error('Calling getConfig with null or undefined argument');
  }

  if (!__BROWSER__) {
    // eslint-disable-next-line global-require
    var config = require('config');

    return config.get(property);
  }

  var value = (0, _prop2.default)("__RELIENT_CONFIG__." + property)(global);

  if (value === undefined) {
    throw new Error("Configuration property \"" + property + "\" is not defined");
  }

  return value;
};

exports.default = _default;